import { useEffect, useState, React } from "react"
import { Button, Form, Modal, Spinner, Table } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import {
  deleteReviewAction,
  fetchReviewsAction,
  updateReviewAction,
} from "../../pages/reviews/reviewAction"
import { NoData } from "../no-data/NoData"
import Rating from "../rating/Rating"
import "./reviewsTable.css"

const ReviewsTable = () => {
  const dispatch = useDispatch()
  const [revs, setRevs] = useState([])
  const [reviewData, setReviewData] = useState()
  const [checked, setChecked] = useState(false)
  const [show, setShow] = useState(false)
  const [shouldFetch, setShouldFetch] = useState(true)
  const [showEditRev, setShowEditRev] = useState(false)
  const { isLoading, reviews } = useSelector((state) => state.review)

  const handleDelete = async (_id) => {
    if (!_id) return

    if (window.confirm("Are you sure you want to delete this review?")) {
      try {
        dispatch(deleteReviewAction(_id))
      } catch (error) {}
    }
  }

  const viewReview = (rev) => {
    setShow(!show)
    setReviewData(rev)
  }

  const editReview = (rev) => {
    setShowEditRev(!showEditRev)
    setReviewData(rev)
  }

  const handleOnSubmit = (_id) => {
    if (!_id) return

    try {
      const update = {
        ...reviewData,
        status: checked === true ? "active" : "inactive",
      }
      dispatch(updateReviewAction(_id, update)) && setShowEditRev(!showEditRev)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    !reviews.length && shouldFetch && dispatch(fetchReviewsAction())
    setRevs(reviews)
    setShouldFetch(false)
  }, [reviews, dispatch, shouldFetch])

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />
  }

  return (
    <div>
      <Modal
        show={show}
        backdrop="static"
        animation={false}
        data={reviewData}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="view-review">
            <h5>
              <b>Student: </b>
              {`${reviewData?.fName} ${reviewData?.lName}`}
            </h5>
            <h5>
              <b>Student email: </b>
              {reviewData?.email}
            </h5>
            <h5>
              <b>Course name: </b>
              {reviewData?.courseName}
            </h5>
            <h5>
              <b>Display in website: </b>
              <span
                className={
                  reviewData?.displayInWebsite === false
                    ? "text-danger"
                    : "text-success"
                }
              >
                {reviewData?.displayInWebsite === false ? "False" : "True"}
              </span>
            </h5>
            <h5 className="d-flex gap-1">
              <b>Rating: </b>

              <Rating rating={reviewData?.rating} />
            </h5>

            <textarea
              disabled
              style={{ width: "100%", padding: ".5rem 1rem" }}
              value={reviewData?.review}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEditRev}
        backdrop="static"
        animation={false}
        data={reviewData}
        onHide={() => setShowEditRev(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Review Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="view-review">
            <h6 className="d-flex gap-1">
              <b>Rating: </b>
              <Rating rating={reviewData?.rating} />
            </h6>

            <textarea
              disabled
              style={{ width: "100%", padding: ".5rem 1rem" }}
              value={reviewData?.review}
            />

            <Form>
              <Form.Group className="d-flex align-items-center gap-2">
                <Form.Label className="mt-1">
                  <strong>Review Status</strong>
                </Form.Label>
                <Form.Check
                  type="switch"
                  defaultChecked={
                    reviewData?.status === "inactive" ? false : true
                  }
                  onChange={(e) => setChecked(e.target.checked)}
                />
              </Form.Group>

              <Button
                variant="success"
                onClick={() => handleOnSubmit(reviewData._id)}
              >
                Update Preference
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <div className="d-flex">
        <div>{reviews?.length} Reviews found!</div>
      </div>

      {!reviews.length ? (
        <NoData />
      ) : (
        <div className="table-responsive">
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Course Name</th>
                <th>Course End Date</th>
                <th>Display in website</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {revs.map((rev, index) => (
                <tr key={rev._id}>
                  <td>{index + 1}</td>
                  <td>{`${rev.fName} ${rev.lName}`}</td>
                  <td>{rev.courseName}</td>
                  <td>{new Date(rev.courseEndDate).toLocaleDateString()}</td>
                  <td
                    className={
                      rev.displayInWebsite === false
                        ? "bg-danger text-light"
                        : "bg-success text-light"
                    }
                  >
                    {rev.displayInWebsite === false ? "FALSE" : "TRUE"}
                  </td>
                  <td
                    className={
                      rev.status === "inactive" ? "text-danger" : "text-success"
                    }
                  >
                    {rev.status}
                  </td>
                  <td className="d-flex justify-content-center gap-2">
                    <Button variant="info" onClick={() => viewReview(rev)}>
                      View
                    </Button>
                    <Button variant="warning" onClick={() => editReview(rev)}>
                      Edit
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => handleDelete(rev._id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}

export default ReviewsTable
